import type { Doc } from "building-types/doc";
import type { SolidFloorAssemblyOverride } from "building-types/floors/floorAssemblyTypes";
import type { ForeignEntityId } from "building-types/handles/foreignEntityId";
import { getFloorSplitData, isHorizontalFloorAssemblyRoomDerived } from "./floorAssembly";
import { collectRoomOutlinesFromDoc, reconcileBaysForRoomOutlines } from "./floorBayRoomDeletionReconcile";
import { floorSplitDataWithReconciledBays } from "./floorSplitDataTools";

export function buildFloorRoomRefMergeProps(
  doc: Doc,
  floor: SolidFloorAssemblyOverride,
  nextEffectiveRoomIds: readonly ForeignEntityId<"ROOM">[],
  refProps: Partial<SolidFloorAssemblyOverride>,
): Partial<SolidFloorAssemblyOverride> {
  if (!isHorizontalFloorAssemblyRoomDerived(floor)) {
    return refProps;
  }

  if (nextEffectiveRoomIds.length === 0) {
    return { ...refProps, splitData: undefined };
  }

  const existingSplitData = getFloorSplitData(floor);
  if (!existingSplitData || Object.keys(existingSplitData.splitLines).length === 0) {
    return {
      ...refProps,
      splitData: undefined,
      ...(floor.floorEdgeOverrides === undefined ? { floorEdgeOverrides: {} } : {}),
      ...(floor.floorOpeningEdgeOverrides === undefined ? { floorOpeningEdgeOverrides: {} } : {}),
    };
  }

  const roomOutlines = collectRoomOutlinesFromDoc(doc, nextEffectiveRoomIds);
  const bays = reconcileBaysForRoomOutlines(roomOutlines, existingSplitData);
  const splitData = floorSplitDataWithReconciledBays(existingSplitData, bays);

  return {
    ...refProps,
    ...(splitData !== undefined ? { splitData } : { splitData: undefined }),
    ...(floor.floorEdgeOverrides === undefined ? { floorEdgeOverrides: {} } : {}),
    ...(floor.floorOpeningEdgeOverrides === undefined ? { floorOpeningEdgeOverrides: {} } : {}),
  };
}
